import {Component, OnInit} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {assignmentType} from '@brands-compart/form-wizard';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {DatagridEmployeeComponent} from '../datagrid/datagrid-employee-component';
import {DatagridService} from '../datagrid/datagrid.service';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-channel-add-existing',
  templateUrl: '../datagrid/datagrid.component.html'
})
export class ChannelAddExistingComponent extends DatagridEmployeeComponent implements OnInit {

  public searchEnabled: boolean = true;
  public assignmentGroupId: number = this.crudConfig.getFilterId();
  public assignmentTypeFilterId: number = this.crudConfig.getFilterId();
  public assignmentStatusFilterId: number = this.crudConfig.getFilterId();
  public overriddenFilterId: number = this.crudConfig.getFilterId();
  private onLink$ = new Subject<void>();

  constructor(
    protected datagridService: DatagridService,
    private router: UIRouter,
    private crudConfig: CrudConfig
  ) {
    super(datagridService);
  }

  public ngOnInit(): void {
    this.datagridListComponent.selected.splice(0, this.datagridListComponent.selected.length);
    this.requestParams
      .addFilterParam({
        id: this.assignmentGroupId,
        key: 'assignmentGroupId',
        operator: 'ne',
        value: this.router.stateService.params.assignmentId
      })
      .addFilterParam({
        id: this.assignmentStatusFilterId,
        key: 'assignment.status',
        operator: 'eq',
        value: 'PROCESSED',
      })
      .addFilterParam({
        id: this.assignmentTypeFilterId,
        key: 'assignment.type',
        operator: 'ne',
        value: assignmentType.SURVEY
      })
      .addFilterParam({
        id: this.overriddenFilterId,
        key: 'overridden',
        operator: 'eq',
        value: 'false',
      });

    this.datagridListComponent.config.throughputSubgrid.enabled = false;
    this.datagridListComponent.config.channelSelector.enabled = true;
    this.datagridListComponent.config.channelSelector.onSelect = this.onSelect.bind(this);
    this.datagridListComponent.config.rowSelector.enabled = true;

    // DO NOT REMOVE THIS LINE!
    this.datagridSearchComponent.ngAfterViewInit = function(): void {};

    this.onFilterOptionsFinished.subscribe(function (finished: boolean) {
      if(finished === true) {
        this.datagridSearchComponent.config.filters.building.value = this.datagridSearchComponent.config.filters.building.options[0].id;

        setTimeout(() => {
          this.datagridSearchComponent.initialized.next(true);
        }, 0);
      }
    }.bind(this));

    super.ngOnInit();
  }

  public onLink(): Observable<void> {
    return this.onLink$;
  }

  public onSelect(selected) {
    this.datagridService.getChannelService().setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
    this.datagridService.getChannelService().link({
      sourceChannelId: selected.map((row) => row.channel.id),
      bIncludeThroughputs: true
    }).subscribe((channel: any) => {
      this.onLink$.next();
      this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-add-existing.component.ts